var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer"},[_c('gradientAnimation',{attrs:{"skewY":0,"bottom":0}}),_c('img',{attrs:{"src":require("@/assets/images/customer.png")}}),_c('p',[_vm._v(_vm._s(_vm.$t('customer.scanTip')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }